var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31.5,
    viewBox: "0 0 27 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-git-network",
    "data-name": "Icon ionic-md-git-network",
    d: "M31.5,6.75a4.5,4.5,0,1,0-6.75,3.9v3.713L18,17.733l-6.75-3.375V10.645a4.5,4.5,0,1,0-4.5,0v6.5l9,4.5v3.712a4.5,4.5,0,1,0,4.5,0V21.642l9-4.5v-6.5A4.509,4.509,0,0,0,31.5,6.75ZM9,3.938A2.813,2.813,0,1,1,6.188,6.75,2.812,2.812,0,0,1,9,3.938Zm9,28.125a2.813,2.813,0,1,1,2.813-2.812A2.812,2.812,0,0,1,18,32.063Zm9-22.5A2.813,2.813,0,1,1,29.813,6.75,2.812,2.812,0,0,1,27,9.563Z",
    transform: "translate(-4.5 -2.25)",
    fill: "#7352ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.9bafbee1b09bd30e65a87ab28b76564a.svg";
export { ForwardRef as ReactComponent };